@if (version) {
    <div class="_version">{{version}}</div>
}
@if (ready && !reloading) {
    @switch (authService.user()?.type) {
        @case ('assistant') {
            <div class="app app--assistant">
                @if (!configService.routeConfig()?.hideTop) {
                    <app-top/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-navigation/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-global-notifications/>
                }
                <router-outlet/>
                @if (!configService.routeConfig()?.hideFooter) {
                    <app-footer/>
                }
            </div>
        }
        @case ('supervisor') {
            <div class="app app--supervisor">
                @if (!configService.routeConfig()?.hideTop) {
                    <app-top/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-navigation/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-global-notifications/>
                }
                <router-outlet/>
                @if (!configService.routeConfig()?.hideFooter) {
                    <app-footer/>
                }
            </div>
        }
        @case ('staff') {
            <div class="app app--staff">
                @if (!configService.routeConfig()?.hideTop) {
                    <app-top/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-navigation/>
                }
                @if (!configService.routeConfig()?.hideNavigation) {
                    <app-global-notifications/>
                }
                <router-outlet/>
                @if (!configService.routeConfig()?.hideFooter) {
                    <app-footer/>
                }
            </div>
        }
        @case ('admin') {
            <div class="app app--admin">
                @if (!configService.routeConfig()?.hideTop) {
                    <app-top [fullWidth]="true"/>
                }
                <div class="admin-router-navigation-wrap">
                    @if (!configService.routeConfig()?.hideNavigation) {
                        <app-admin-navigation/>
                    }
                    <router-outlet/>
                </div>
            </div>
        }
        @default {
            <div class="app app--public">
                <!-- public -->
                @if (!configService.routeConfig()?.hideTop) {
                    <app-top [boxedWidth]="true"/>
                }
                <router-outlet/>
            </div>
        }
    }
}